import { render } from "./dashboard-sms-usage.vue?vue&type=template&id=30dc8b2e"
import script from "./dashboard-sms-usage.vue?vue&type=script&lang=js"
export * from "./dashboard-sms-usage.vue?vue&type=script&lang=js"
script.render = render

export default script